import {CHANGE_MAIN} from './constants'

export default function changeMain(main){
    return {
        type: CHANGE_MAIN,
        main
    }
}


// WEBPACK FOOTER //
// ./src/actions/main.js